import { ChangeEventHandler } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5em;
`;

const Control = styled.div`
  flex: 0;
`;

const Input = styled.input`
  opacity: 0;
  position: absolute;

  &:checked + label {
    background-color: var(--cerulean);
    color: var(--white);
    font-weight: 500;
  }
`;

const Label = styled.label`
  display: block;
  cursor: pointer;
  width: 100%;
  padding: 0.6em 0.5em;
  background-color: var(--cerulean20);
  border-radius: 0.25em;
  color: var(--cerulean);
  text-align: center;
  min-width: 50px;
  transition: background-color 0.5s, color 0.5s;
`;

type SegmentedControlProps = {
  id?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClick?: (e: React.MouseEvent) => void;
  value?: string;
  options: {
    label: string;
    value: string;
    id?: string;
  }[];
  name: string;
};

const SegmentedControl = ({
  onChange,
  onClick,
  value,
  options,
  name,
}: SegmentedControlProps) => {
  return (
    <Wrapper role="radiogroup" id={`${name}`} aria-label={`${name}`}>
      {options.map((option) => {
        return (
          <Control key={`${name}_${option.id || option.value}`}>
            <Input
              type="radio"
              value={option.value}
              name={name}
              id={`${name}_${option.id || option.value}`}
              checked={!!value && value === option.value}
              aria-label={`${name}_${option.id || option.value}`}
              onChange={onChange}
              onClick={onClick}
            />
            <Label htmlFor={`${name}_${option.id || option.value}`}>
              {option.label}
            </Label>
          </Control>
        );
      })}
    </Wrapper>
  );
};

export default SegmentedControl;
